import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "box-column" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "box-column" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "content overflow-auto" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = {
  class: "q-pa-md text-primary text-right cursor-pointer",
  clickable: ""
}
const _hoisted_9 = { class: "box-column" }
const _hoisted_10 = { class: "header" }
const _hoisted_11 = { class: "content overflow-auto" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["src", "height"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = {
  class: "q-pa-md text-primary text-right cursor-pointer",
  clickable: ""
}

import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from "vue";
  import { Dialog, AppVisibility, LocalStorage } from "quasar";
  import { useRoute, useRouter } from "vue-router";

  import { useAuthStore } from "src/stores/auth-store";
  import { useProposalStore } from "src/stores/proposal-store";
  import { useSettingsStore } from "src/stores/settings-store";
  import { useVehicleStore } from "src/stores/vehicle-store";
  import { useWebSocketStore } from "src/stores/websocket-store";

  import Help from "src/components/help/Help.vue";
  import { DealerInfo } from "src/types/dealer/index";
  import { DealerService } from "src/services";
  import PortalVersion from "src/types/dealer/portal-version";

  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  emits: ["selectDealer"],
  setup(__props, { expose: __expose, emit: __emit }) {

  const route = useRoute();
  const router = useRouter();
  const authStore = useAuthStore();
  const proposalStore = useProposalStore();
  const settingsStore = useSettingsStore();
  const vehicleStore = useVehicleStore();
  const wsStore = useWebSocketStore();

  const banned = [ 44499, 45683, 39563, 46981, 39760 ];

  onBeforeMount(() => {
    settingsStore.updateIsDark(settingsStore.isDark);
  })

  onMounted(() => {
    if (dealers.value && dealers.value.length > 0 && !authStore.selectedDealers) {
      selectDealer();
    }
    if (authStore.dealerId > -1 && vehicleStore.vehicles.length === 0) {
      vehicleStore.getStockVehicles();
    }
    if (authStore.affiliateUserId) {
      proposalStore.getBespokeRates(authStore.affiliateUserId);
      subscribe(authStore.affiliateUserId);
    }
    if (authStore.selectedDealers) {
      wsStore.reconnect().catch(() => {
        console.error("WebSocket reconnection failed");
      })
    }
    if(banned.includes(authStore.dealerId)){
      Dialog.create({
        title: "Banned",
        message: "You have been banned from the system. Please contact support."
      })
      authStore.logout(true);
      return;
    }

    if(authStore.isDealer && !LocalStorage.getItem("dealer")){
      DealerService.getDealers().then((dealers) => {
        const dealer = dealers.find(d => d.dealerId === authStore.dealerId);

        if(!dealer){
          Dialog.create({
            title: "Not Live",
            message: "You are not authorised to access the system. Please contact support."
          })
          authStore.logout(true);
          return;
        }

        LocalStorage.setItem("dealer", JSON.stringify(dealer));
      })
    }
  })

  const isMobile = computed(() => settingsStore.isMobile);

  const aid = computed(() => authStore.affiliateUserId);
  watch(aid, () => {
    if (aid.value) {
      proposalStore.getBespokeRates(aid.value);
      subscribe(aid.value);
    }
  })

  const portalVersions = ref<PortalVersion[]>([]);
  const did = computed(() => authStore.dealerId);
  watch(did, () => {
    if (did.value > -1) {
      try{
        DealerService.getPortalVersions()
        .then((res) => {
          portalVersions.value = res;
          const did = authStore.dealerId;
          const host = window.location.host;
          const isV3 = res.find(v => v.dealerId == did && v.isV3) ? true : false;
          const isOnV3Url = host.toLowerCase().indexOf("kind-glacier") > -1 || host.toLowerCase().indexOf("dealerv2") > -1;
          const t = JSON.parse(JSON.stringify(authStore.token.authenticationToken));
          if(isV3 && !isOnV3Url){
            Dialog.create({
              title: "Portal Updated",
              message: "A new version of the portal is available. You will be redirected to the new portal.",
              persistent: true,
              ok: "Take me there!"
            }).onOk(() => {
              window.location.href = host.toLowerCase().indexOf("white-meadow") > -1 ? `https://kind-glacier-04d3c6a03.5.azurestaticapps.net/login?ut=${t}` : `https://dealerv2.carfinance247.co.uk/login?ut=${t}`;
            })
          }
          else if(!isV3 && isOnV3Url){
            window.location.href = host.toLowerCase().indexOf("kind-glacier") > -1 ? `https://white-meadow-05081ef03.2.azurestaticapps.net/login?ut=${t}` : `https://dealer.carfinance247.co.uk/login?ut=${t}`;
          }
        })
      } 
      catch(e){
        console.error(e);
      }
    }
  }, { immediate: true })

  const appVisible = computed(() => AppVisibility.appVisible);
  watch(() => appVisible.value, (nVal: boolean, oVal: boolean) => {
    wsStore.reconnect().catch(() => {
      console.error("WebSocket reconnection failed");
    })
  })

  function subscribe(aid: number) {
    wsStore.connect(aid.toString()).catch(() => {
      console.error("WebSocket connection failed");
    })
  }

  const dealers = computed(() => authStore.dealers);
  watch(dealers, (newVal: DealerInfo[] | null, oldVal: DealerInfo[] | null) => {

    if (newVal && newVal.length > 0) {
      selectDealer();
    }
    if (newVal && newVal.length === 0) {
      authStore.logout(true);
      Dialog.create({
        persistent: true,
        title: "Unauthorised",
        message: "You are not authorised to use the Dealer Portal."
      }).onOk(() => {

      })
    }
  })
  const emit = __emit;
  function selectDealer() {
    emit("selectDealer");
  }
  const showHelp = ref(false);
  const isYopmail = computed(() => authStore.isYopmail);

  function navigate(to: string) {
    switch (to) {
      case "customers":
        selectedTab.value = to;
        router.push({ name: "Customers" });
        break;
      case "stock":
        selectedTab.value = to;
        router.push({ name: "Stock" });
        break;
      case "help":
        showHelp.value = true;
        break;
      case "budget-calculator":
        selectedTab.value = to;
        router.push({ name: "BudgetCalculator" });
        break;
      case "account":
        selectedTab.value = to;
        router.push({ name: "Account" });
        break;
      case "settings":
        selectedTab.value = to;
        router.push({ name: "Settings" });
        break;
    }
  }

  // Tab highlight indicator switch
  const selectedTab = ref("home");
  function tabDetect() {
    switch (route.path) {
      case "/":
        selectedTab.value = "customers";
        break;
      case "/quotes":
        selectedTab.value = "quotes";
        break;
      case "/proposals":
        selectedTab.value = "proposals";
        break;
      case "/help":
        selectedTab.value = "help";
        break;
      case "/stock":
        selectedTab.value = "stock";
        break;
      case "/budget-calculator":
        selectedTab.value = "budget-calculator";
        break;
    }
  }
  tabDetect();
  watch(route, () => {
    tabDetect();
  });

  const showDrawer = ref(isMobile ? false : true);

  const drawerMini = ref(true)

  const loggingOut = ref(false);
  function logout() {
    loggingOut.value = true;
    Dialog.create({
      title: "Warning",
      message: "Are you sure you want to log out?",
      ok: "Yes",
      cancel: "No",
    }).onOk(() => {
      loggingOut.value = false;
      authStore.logout(true);
    }).onCancel(() => {
      loggingOut.value = false;
    })
  }

  __expose({ toggleDrawer })
  function toggleDrawer() {
    showDrawer.value = !showDrawer.value;
  }

  const showRegisterInterests = ref(false);
  watch(showRegisterInterests, (newVal: boolean, oldVal: boolean) => {
    if (newVal) {
      pulseIcon.value = false;
      localStorage.setItem('registeredInterestsButtonClicked', 'true');
    }
  })

  const canRegisterInterests = computed(() => {
    const canReg = authStore.user && 
      (authStore.user.roles.includes("DealerManager") || 
       authStore.user.roles.includes("SuperUser"));
    return canReg || authStore.isIntranetUser;
  });

  const hasRegisteredInterests = computed(() => {
    const did = authStore.selectedDealers ? authStore.selectedDealers[0].dealerId : authStore.dealerId;
    const cookie = JSON.parse(localStorage.getItem('interestsRegistered') ?? "{}") as { dealerId: number, complete: boolean };
    return (cookie && cookie.complete && cookie.dealerId == did) || submitted.value;
  })

  const tfSrc = computed(() => {    
    const did = authStore.selectedDealers ? authStore.selectedDealers[0].dealerId : authStore.dealerId;
    const dname = authStore.selectedDealers ? authStore.selectedDealers[0].name : authStore.dealerName;

    return `https://carfinance247.typeform.com/to/OztOfUXg#dealer_id=${did}&dealer_name=${dname}&user_name=${authStore.userName}`
  })

  const typeformHeight = ref(400);

  window.addEventListener('message', (event) => handleTypeformEvent(event), false);

  onBeforeUnmount(() => {
    window.removeEventListener('message', (event) => handleTypeformEvent(event), false);
  })

  const submitted = ref(false);
  function handleTypeformEvent(event: MessageEvent) {
    if(event.data && event.data.type && event.data.type == 'form-submit'){
      const did = authStore.selectedDealers ? authStore.selectedDealers[0].dealerId : authStore.dealerId;
      localStorage.setItem('interestsRegistered', JSON.stringify({ dealerId: did, complete: true }));
      typeformHeight.value = 400;
      submitted.value = true;
    }
    if(event.data && event.data.type && event.data.type == 'form-height-changed'){
      typeformHeight.value = event.data.height;
    }
  }

  const hasClickedButton = localStorage.getItem('registeredInterestsButtonClicked') && JSON.parse(localStorage.getItem('registeredInterestsButtonClicked') ?? "false") == true;
  const pulseIcon = ref(hasClickedButton ? false : hasRegisteredInterests.value ? false : true);
  setTimeout(() => {
    pulseIcon.value = false;
  }, 60000);


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authStore).isAuthenticated)
      ? (_openBlock(), _createBlock(_component_q_drawer, {
          key: 0,
          modelValue: showDrawer.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDrawer).value = $event)),
          "show-if-above": "",
          side: "left",
          mini: drawerMini.value,
          "mini-width": 72,
          width: 240,
          breakpoint: 500,
          bordered: "",
          behavior: isMobile.value ? 'mobile' : 'desktop',
          class: "bg-accent text-white test-subtitle1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_list, { padding: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_q_img, {
                              src: require('assets/logos/247-logo-stacked.svg'),
                              width: "70px",
                              class: "q-mx-auto"
                            }, null, 8, ["src"]), [
                              [_vShow, !drawerMini.value]
                            ]),
                            _withDirectives(_createVNode(_component_q_img, {
                              src: require('assets/img/smile_white.svg'),
                              width: "50px",
                              class: "q-mx-auto"
                            }, null, 8, ["src"]), [
                              [_vShow, drawerMini.value]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      class: "text-body2",
                      "active-class": "text-white bg-translucent text-weight-bold",
                      active: selectedTab.value === 'customers',
                      "data-cy": "customersNav",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('customers')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-account-group" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode(" Customers ")
                          ])),
                          _: 1,
                          __: [11]
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      class: "text-body2",
                      "active-class": "text-white bg-translucent text-subtitle2",
                      active: selectedTab.value === 'stock',
                      "data-cy": "stockNav",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate('stock')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-car" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode(" Stock Feed ")
                          ])),
                          _: 1,
                          __: [12]
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      id: "budget-calc-button",
                      class: "text-body2",
                      "active-class": "text-white bg-translucent text-subtitle2",
                      active: selectedTab.value === 'budget-calculator',
                      "data-cy": "calcNav",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('budget-calculator')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-calculator" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" Calculator ")
                          ])),
                          _: 1,
                          __: [13]
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])), [
                      [_directive_ripple]
                    ]),
                    (canRegisterInterests.value)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          clickable: "",
                          class: "text-body2",
                          "active-class": "text-white bg-translucent text-subtitle2",
                          "data-cy": "calcNav",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showRegisterInterests.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { avatar: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: "mdi-currency-gbp",
                                  class: _normalizeClass(pulseIcon.value ? 'update-ripple rounded-borders' : '')
                                }, null, 8, ["class"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode(" Payments ")
                              ])),
                              _: 1,
                              __: [14]
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_ripple]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_list, { padding: "" }, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (navigate('settings')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-cog" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode(" Settings ")
                          ])),
                          _: 1,
                          __: [15]
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      class: "text-body2",
                      active: showHelp.value,
                      "active-class": "text-white bg-translucent text-subtitle2",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showHelp.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-help-circle" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode(" Help ")
                          ])),
                          _: 1,
                          __: [16]
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])), [
                      [_directive_ripple]
                    ]),
                    (_unref(authStore).canChangeDealer)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          clickable: "",
                          class: "text-body2",
                          onClick: selectDealer
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { avatar: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "mdi-map-marker" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode(" Dealer Select ")
                              ])),
                              _: 1,
                              __: [17]
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_ripple]
                        ])
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (navigate('account')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "mdi-account-circle" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, { class: "text-subtitle1 full-width" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(authStore).userName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_label, {
                              caption: "",
                              class: "text-body2 text-white full-width"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(authStore).dealerName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_ripple]
                    ]),
                    (!isMobile.value)
                      ? (_openBlock(), _createBlock(_component_q_separator, {
                          key: 1,
                          color: "grey-9 q-ma-md"
                        }))
                      : _createCommentVNode("", true),
                    (!isMobile.value)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 2,
                          clickable: "",
                          class: "text-body2",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (drawerMini.value = !drawerMini.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { avatar: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: drawerMini.value ? 'mdi-arrow-expand-right' : 'mdi-arrow-collapse-left'
                                }, null, 8, ["name"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode(" Collapse ")
                              ])),
                              _: 1,
                              __: [18]
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_ripple]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "mini", "behavior"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: showHelp.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showHelp).value = $event)),
      maximized: isMobile.value,
      "transition-show": isMobile.value ? 'slide-up' : 'scale',
      "transition-hide": isMobile.value ? 'slide-down' : 'scale'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_q_card_section, { class: "row items-center q-py-sm" }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-h6" }, null, -1)),
                    _createVNode(_component_q_space),
                    _withDirectives(_createVNode(_component_q_btn, {
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1,
                  __: [19]
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(Help)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, _cache[20] || (_cache[20] = [
                  _createElementVNode("span", { class: "text-subtitle1" }, "Close", -1)
                ]))), [
                  [_directive_ripple],
                  [_directive_close_popup]
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "maximized", "transition-show", "transition-hide"]),
    _createVNode(_component_q_dialog, {
      modelValue: showRegisterInterests.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showRegisterInterests).value = $event)),
      maximized: isMobile.value,
      "transition-show": isMobile.value ? 'slide-up' : 'scale',
      "transition-hide": isMobile.value ? 'slide-down' : 'scale'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_card_section, { class: "row items-center q-py-sm" }, {
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-h6" }, "Register Interest", -1)),
                    _createVNode(_component_q_space),
                    _withDirectives(_createVNode(_component_q_btn, {
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1,
                  __: [21]
                }),
                _createVNode(_component_q_separator)
              ]),
              _createElementVNode("div", _hoisted_11, [
                (!hasRegisteredInterests.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("iframe", {
                        src: tfSrc.value,
                        height: typeformHeight.value,
                        frameborder: "0",
                        marginheight: "0",
                        marginwidth: "0",
                        style: {"width":"100%"},
                        scrolling: "no"
                      }, null, 8, _hoisted_13)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[22] || (_cache[22] = [
                      _createElementVNode("div", { class: "q-pa-md text-body1 text-dark" }, " Thank you for registering your interest in Boodil payments. A member of our team will be in touch! ", -1)
                    ])))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_q_separator),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, _cache[23] || (_cache[23] = [
                  _createElementVNode("span", { class: "text-subtitle1" }, "Close", -1)
                ]))), [
                  [_directive_ripple],
                  [_directive_close_popup]
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "maximized", "transition-show", "transition-hide"])
  ], 64))
}
}

})